if (!customElements.get('combine-set-tabs')) {
  customElements.define(
    'combine-set-tabs',
    class CombineSetTabs extends HTMLElement {
      constructor() {
        super();
        this.hasSet = this.dataset.hasSet === 'true';
        this.combineHasProducts = null;
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.combine-set-tabs__tab'));
        this.panels = Array.from(this.querySelectorAll('.combine-set-tabs__panel'));
        this.combineTab = this.querySelector('[data-cs-tab="combine"]');
        this.setTab = this.querySelector('[data-cs-tab="set"]');
        this.combineRecommendations = this.querySelector('product-recommendations');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.onTabClick(tab));
        });

        // React to the async complementary products load.
        if (this.combineRecommendations) {
          this.combineRecommendations.addEventListener('recommendations:loaded', () => this.onCombineLoaded());
          this.combineRecommendations.addEventListener('recommendations:empty', () => this.onCombineEmpty());
        }

        // Default active tab: combine.
        this.activateTab('combine');

        // Without a set, keep the block hidden until we know the async
        // complementary products actually returned something. This avoids a
        // flash of empty tabs on products that have neither.
        if (!this.hasSet) {
          this.hidden = true;
        }

        // On mobile, move the whole complementary block above the buy buttons
        // (+ quantity selector) to give more focus to the upsell. Desktop keeps
        // the original position.
        this.setupMobileReorder();
      }

      setupMobileReorder() {
        const block = this.closest('.product__block');
        if (!block) return;
        const container = block.parentElement;
        if (!container) return;
        const buyBlock = container.querySelector('.product__block--buy_buttons');
        if (!buyBlock || buyBlock === block) return;

        // Remember the original (desktop) position with a placeholder.
        const placeholder = document.createComment('complementary-block-position');
        block.parentNode.insertBefore(placeholder, block);

        const mqString =
          (window.FoxTheme && FoxTheme.config && FoxTheme.config.mediaQueryMobile) || '(max-width: 767px)';
        const mql = window.matchMedia(mqString);

        const apply = () => {
          if (mql.matches) {
            if (buyBlock.previousElementSibling !== block) {
              container.insertBefore(block, buyBlock);
            }
          } else if (placeholder.parentNode && placeholder.nextSibling !== block) {
            placeholder.parentNode.insertBefore(block, placeholder.nextSibling);
          }
        };

        apply();

        if (mql.addEventListener) {
          mql.addEventListener('change', apply);
        } else if (mql.addListener) {
          mql.addListener(apply);
        }
      }

      onTabClick(tab) {
        if (tab.hasAttribute('disabled') || tab.classList.contains('is-disabled')) return;
        this.activateTab(tab.dataset.csTab);
      }

      activateTab(name) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.csTab === name;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.csPanel !== name;
        });
      }

      onCombineLoaded() {
        this.combineHasProducts = true;
        this.hidden = false;
      }

      onCombineEmpty() {
        this.combineHasProducts = false;

        // Hide the (now empty) combine tab and panel.
        if (this.combineTab) this.combineTab.hidden = true;
        const combinePanel = this.querySelector('[data-cs-panel="combine"]');
        if (combinePanel) combinePanel.hidden = true;

        if (this.hasSet) {
          // Fall back to the set tab and make it the active option.
          if (this.setTab) {
            this.setTab.hidden = false;
            this.setTab.classList.remove('is-disabled');
            this.setTab.removeAttribute('disabled');
            this.setTab.removeAttribute('aria-disabled');
          }
          this.activateTab('set');
        } else {
          // Nothing to show at all – remove the whole product block.
          const block = this.closest('.product__block');
          if (block) block.remove();
        }
      }
    }
  );
}
